// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"a644d227","887":"03669bc7"}[chunkId] + ".chunk.js";
};